import React, { useCallback } from "react";
import { useAppDispatch } from "@app/state";
import { setCurrentUserTreeListItem } from "@app/state/units";
import {
  selectUserTreeList,
  selectCurrentUserTreeList,
} from "@app/state/units";
import { JGAPCommonTree } from "@app/components/treeListCommon";
import { UserListTitle, UserListIco } from "./items";

import "./userstree.scss";

export const UsersTree = () => {
  const dispatch = useAppDispatch();
  const cellRender = useCallback(
    (e: any) => (
      <div>
        <UserListIco e={e} />
        <UserListTitle e={e} />
      </div>
    ),
    []
  );

  const tlSelectionChanged = useCallback((e: any) => {
    dispatch(setCurrentUserTreeListItem(e.selectedRowsData[0]));
  }, []);

  return (
    <JGAPCommonTree
      treeId={"usersTreeList"}
      treeDataSelector={selectUserTreeList}
      currenNodeSelector={selectCurrentUserTreeList}
      cellRender={cellRender}
      treeSelectionChanged={tlSelectionChanged}
    />
  );
};
